import {Component} from '@lib/Component';
import * as rules from '@lib/validation/rules';
import {validate, Validator} from '@lib/validation/validators';

export interface IField<THTMLElement extends HTMLElement = HTMLDivElement> {
  setInvalid(error: string): void;

  getElement(): THTMLElement | null;

  get touched(): boolean;

  get isValid(): boolean;

  get value(): string;

  set value(val: string);

  get name(): string;
}

type rulesType = typeof rules;

export function getRules<K extends keyof rulesType>(input: K): rulesType[K] {
  return rules[input];
}

export abstract class BaseFormField<
    THTMLElementType extends HTMLElement = HTMLDivElement,
  >
  extends Component<THTMLElementType>
  implements IField<THTMLElementType>
{
  error: HTMLElement | undefined = undefined;
  errors: string[] | null = [];
  rules: Validator[] | undefined = undefined;
  _touched: boolean = false;

  public onChange() {
    this._touched = true; // 確認ボタンを押した場合にtouchedを再現する
    this.validate();
    this.render();
    this.emit('change');
  }

  public onBlur() {
    if (this._touched) {
      this.confirm();
    }
  }

  public confirm() {
    const ret = this.validate();
    this.render();
    return ret;
  }

  didMount() {
    this.error = this.element?.querySelector('.js-field-error') as HTMLElement;

    if (this.element?.dataset.rules) {
      // TODO: types
      /* etc: data-rules="required emailFormat" */
      this.rules = (
        this.element?.dataset.rules?.split(/\s/).map((v) => {
          return getRules(v as keyof rulesType);
        }) as Validator[]
      ).filter((v) => !!v);
    }
  }

  public setInvalid(error: string): void {
    if (this.errors) {
      this.errors = [...this.errors, error];
    } else {
      this.errors = [error];
    }
    this.render();
  }

  abstract set readonly(val: boolean);

  abstract get value(): string;

  abstract get name(): string;

  getElement(): THTMLElementType | null {
    return this.element;
  }

  get isValid() {
    return !(this.errors && this.errors.length);
  }

  get touched() {
    return this._touched;
  }

  public validate(): boolean {
    this.errors = validate(this.rules, this.value);
    return this.isValid;
  }

  private render() {
    if (this.isValid) {
      this.element?.classList.remove('invalid');
      if (this.error) {
        this.error.textContent = '';
      }
    } else {
      this.element?.classList.add('invalid');
      if (this.error) {
        this.error.textContent = this.errors?.join(',') || '';
      }
    }
  }
}
